module.exports = __webpack_public_path__ + "exo-latin-500.c616c256d4843cc16357.eot";


//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/typeface-exo/files/exo-latin-500.eot
// module id = ../../../../typeface-exo/files/exo-latin-500.eot
// module chunks = styles